/** Offset sub-tool icon (issue #29), read from `src/icons/offset-tool.svg`
 *  through the shared {@link stripIconSvg} (#216). Shared between the
 *  construction sub-toolbar button, the layers-panel "offset" chip, and the
 *  Offset tile in the shape galleries, so all three reuse the same visual. */
import offsetToolRaw from "./offset-tool.svg?raw";
import { stripIconSvg } from "./stripIconSvg";

export const OFFSET_TOOL_ICON_SVG = stripIconSvg(offsetToolRaw);
